export const authHost = `${process.env.AUTH_HOST}/query`
export const graphQLHost = process.env.GRAPHQL_HOST

export const GRAPHQL_SERVER_HOST = {
  FMS: `${process.env.GRAPHQL_HOST}/query`,
  IDM: `${process.env.GRAPHQL_HOST_IDM}/query`,
}

export const idmHost = process.env.IDM_HOST
export const fmsHost = process.env.FMS_HOST
export const fmsHostAlva = process.env.FMS_HOST_ALVA
export const idmHostAlva = process.env.IDM_HOST_ALVA
export const fmsHostTricon = process.env.FMS_HOST_TRICON
export const fmsHostXL = process.env.FMS_HOST_XL || 'https://xl.fleeto.id'
export const idmHostXL = process.env.IDM_HOST_XL || 'https://xl-idm.fleeto.id'
export const fmsKalistaKMove =
  process.env.FMS_HOST_KALISTA_K_MOVE || 'https://k-move.kalista.id'
export const idmKalistaKMove =
  process.env.IDM_HOST_KALISTA_K_MOVE || 'https://k-move-idm.kalista.id'
export const fmsKalista =
  process.env.FMS_HOST_KALISTA || 'https://kmove.kalista.id'
export const idmKalista =
  process.env.IDM_HOST_KALISTA || 'https://kmove-idm.kalista.id'

export const unleashHost = `${process.env.UNLEASH_HOST}/api/frontend`
export const unleashTokenAPI = process.env.UNLEASH_TOKEN

export const streamaxHost =
  process.env.STREAMAX_HOST || 'https://apis.fleeto.id'

export const wsHost = process.env.WS_HOST
export const wsToken = process.env.WS_TOKEN
export const wsChannel = process.env.WS_CHANNEL
export const mapsApiKey = process.env.MAPS_API_KEY
export const intervalPopupInMS = parseInt(
  process.env.AUTOCLOSE_IMEI_POPUP_INTERVAL
)

// export const mapUrl = `https://api.maptiler.com/maps/streets/256/{z}/{x}/{y}.png?key=KwWLYSD2MU0b5Rmx2PpM`
// export const mapUrl = `https://api.maptiler.com/maps/streets/256/{z}/{x}/{y}.png?key=AOxi5FF3Km04TA7ALfxf`

const mapTilerKey =
  process.env.NODE_ENV === 'production'
    ? 'UOoqEet53AOizVtvK7Dp' // prod
    : 'JUfj3h98Lt8ZDYPECerD' // dev

export const mapUrl = `https://api.maptiler.com/maps/streets/256/{z}/{x}/{y}.png?key=${mapTilerKey}`

export const mapSatelite =
  'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}?token=AAPKece0053a7b12411985a0f5b94bb6f7e2B451NPKcV6bvyOQi9av57Ck9KiKujXZJywIFrBEhNxhntjdeAMvsEFoh6I1MvBAB'

export const CHANNEL_KEY = {
  POSITIONS: 'positions',
}

export const graphqlDefaultOptions = {
  pollInterval: 1000 * 60 * 5, // 5 Minutes
  notifyOnNetworkStatusChange: true,
}

export const blacklistedUser = process.env.BLACKLISTED_USER

export const ALLOWED_DOMAINS = [
  'xtrip.link',
  'xapiens.id',
  'alvaauto.com',
  'xtrip.click',
  'fleeto.id',
]

export const thisLink = 'kalista'

export const SUBDOMAINS = {
  FLEETO_MAIN_SUBDOMAIN: fmsHost.split('.')[0].replace(/^https?:\/\//, ''),
  FLEETO_ALVA_SUBDOMAIN: fmsHostAlva.split('.')[0].replace(/^https?:\/\//, ''),
  FLEETO_XL_SUBDOMAIN: fmsHostXL.split('.')[0].replace(/^https?:\/\//, ''),
  FLEETO_KALISTA_SUBDOMAIN: fmsKalista
    .split('.')[0]
    .replace(/^https?:\/\//, ''),
  FLEETO_KALISTA_K_MOVE_SUBDOMAIN: fmsKalistaKMove
    .split('.')[0]
    .replace(/^https?:\/\//, ''),
  FLEETO_TRICON_SUBDOMAIN: fmsHostTricon
    ?.split('.')[0]
    .replace(/^https?:\/\//, ''),
}

export const currentSubdomain = window.location.hostname.split('.')[0]

export const currentDomain = window.location.hostname.split('.')[1]

export const DOMAINS_IDM = {
  FLEETO_MAIN_DOMAIN: idmHost?.split('.')[1].replace(/^https?:\/\//, ''),
  FLEETO_ALVA_DOMAIN: idmHostAlva?.split('.')[1].replace(/^https?:\/\//, ''),
  FLEETO_XL_DOMAIN: idmHostXL?.split('.')[1].replace(/^https?:\/\//, ''),
  FLEETO_KALISTA_DOMAIN: idmKalista?.split('.')[1].replace(/^https?:\/\//, ''),
  FLEETO_KALISTA_K_MOVE_DOMAIN: idmKalistaKMove
    ?.split('.')[1]
    .replace(/^https?:\/\//, ''),
}

export const DOMAINS = {
  FLEETO_MAIN_DOMAIN: fmsHost?.split('.')?.[1]?.replace(/^https?:\/\//, ''),
  FLEETO_ALVA_DOMAIN: fmsHostAlva?.split('.')?.[1]?.replace(/^https?:\/\//, ''),
  FLEETO_XL_DOMAIN: fmsHostXL?.split('.')?.[1]?.replace(/^https?:\/\//, ''),
  FLEETO_KALISTA_DOMAIN: fmsKalista
    ?.split('.')?.[1]
    ?.replace(/^https?:\/\//, ''),
  FLEETO_KALISTA_K_MOVE_DOMAIN: fmsKalistaKMove
    ?.split('.')?.[1]
    ?.replace(/^https?:\/\//, ''),
  FLEETO_TRICON_DOMAIN: fmsHostTricon
    ?.split('.')?.[1]
    ?.replace(/^https?:\/\//, ''),
}

export const idmHostMapping = {
  [DOMAINS_IDM.FLEETO_ALVA_DOMAIN as string]: idmHostAlva,
  [DOMAINS_IDM.FLEETO_MAIN_DOMAIN as string]: idmHost,
  [DOMAINS_IDM.FLEETO_XL_DOMAIN as string]: idmHostXL,
  [DOMAINS_IDM.FLEETO_KALISTA_DOMAIN as string]: idmKalista,
  [DOMAINS_IDM.FLEETO_KALISTA_K_MOVE_DOMAIN as string]: idmKalistaKMove,
}

export const redirectIdmHost = idmHostMapping[currentDomain] || idmHost

export const MFA_CODE = {
  MFA_SETUP_REQUIRED: 'MFA_SETUP_REQUIRED',
  MFA_VERIFICATION_REQUIRED: 'MFA_VERIFICATION_REQUIRED',
  EMAIL_OTP_REQUIRED: 'EMAIL_OTP_REQUIRED',
}
